import axios from "axios";

export const getAssignments = async (params) => {
  const { data } = await axios.get("/api/assignments", { params });
  return data;
};

export const getAssignment = async (id) => {
  const { data } = await axios.get(`/api/assignments/${id}`);
  return data;
};

export const createAssignment = async (payload) => {
  const { data } = await axios.post("/api/assignments", payload);
  return data;
};

export const updateAssignment = async (id, payload) => {
  const { data } = await axios.put(`/api/assignments/${id}`, payload);
  return data;
};

export const deleteAssignment = async (id) => {
  const { data } = await axios.delete(`/api/assignments/${id}`);
  return data;
};

export const publishAssignment = async (id) => {
  const { data } = await axios.post(`/api/assignments/${id}/publish`);
  return data;
};

export const submitAssignment = async (id, payload) => {
  const { data } = await axios.post(`/api/assignments/${id}/submit`, payload);
  return data;
};

export const gradeSubmission = async (submissionId, payload) => {
  const { data } = await axios.put(`/api/assignments/submissions/${submissionId}/grade`, payload);
  return data;
};
